import React from 'react';
import { Download, LoaderCircle } from 'lucide-react';
import { usePwaInstall } from '../hooks/usePwaInstall';

export default function PwaInstallButton({
  className = '',
  label = 'Install App',
  variant = 'hero',
}) {
  const { canShowInstallButton, isInstalling, promptInstall } = usePwaInstall();

  if (!canShowInstallButton) return null;

  const baseHero =
    'inline-flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-white/5 px-6 py-3 font-semibold text-brand-gold hover:bg-brand-gold/15 hover:text-white transition disabled:opacity-70 disabled:cursor-wait';
  const baseProfile =
    'flex w-full items-center justify-between rounded-[22px] bg-[#232323] px-4 py-4 text-left shadow-[0_12px_24px_rgba(0,0,0,0.28)] transition active:scale-[0.99] disabled:opacity-70 disabled:cursor-wait';

  if (variant === 'profile') {
    return (
      <button
        type="button"
        onClick={() => {
          promptInstall();
        }}
        disabled={isInstalling}
        className={`${baseProfile} ${className}`.trim()}
      >
        <span className="flex items-center gap-3">
          <span className="grid h-8 w-8 place-items-center rounded-full bg-white/5 text-brand-gold">
            {isInstalling ? <LoaderCircle size={16} className="animate-spin" /> : <Download size={16} />}
          </span>
          <span className="text-[14px] font-medium text-white/90">
            {isInstalling ? 'Installing…' : label}
          </span>
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => {
        promptInstall();
      }}
      disabled={isInstalling}
      className={`${baseHero} ${className}`.trim()}
    >
      {isInstalling ? <LoaderCircle size={18} className="animate-spin" /> : <Download size={18} />}
      {isInstalling ? 'Installing…' : label}
    </button>
  );
}
